import {styled} from "@mui/material/styles";
import { Grid, FormControlLabel } from '@mui/material';
import { useColors } from "../../../../Context/ColorsContext";
import { MediaQuerys } from "../../../../styles/GlobalStyle";

const { desktop } = MediaQuerys;

export const CustomGrid = styled(Grid)(() => {
    return {
        display: 'flex',
        flexDirection: 'row',
        border: '1px solid #ccc',
        borderRadius: '8px',
        minWidth: 500,
        flex: 1,
        overflow: 'auto',
        alignContent: 'flex-start',
        '> .MuiGrid-item': {
            padding: 6,
            paddingTop: 8,
            paddingBottom: 8,
            borderBottom: '1px solid #e4e7eb',
        }
    }
})

export const StickyHeader = styled(Grid)(({ theme }) => {
    const { colors } = useColors();
    return {
        position: "sticky",
        top: 0,
        height: 'auto',
        color: colors.navbarColor,
        backgroundColor: '#eeeeee', // Customize this background color as needed
        zIndex: 1, // Ensure the header stays above the content when scrolling
        fontWeight: 'bold',
        fontSize: '14px',
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        paddingTop: '8px !important',
        paddingBottom: '8px !important',
        [theme.breakpoints.down('md')]: {
          fontSize: '12px',
        },
    };
});



export const CustomControlLabel = styled(FormControlLabel)(() => {
    return {
        margin: 0,
      [desktop]: {
        '& .MuiTypography-root': {
          fontSize: '0.85rem',
        }
      }
    }
  })
